module.exports = __webpack_public_path__ + "img/story_2_hamburger@3x.7ac36090.png";